import React from 'react'
import GetAvatarText from 'Lib/GetAvatarText'
import GetAvatarColor from 'Lib/GetAvatarColor'
import styles from './AvatarStyles'

const Avatar = ({ name, radius, fontSize, selected }) => {
  const circleStyle = {
    width:`${radius}px`,
    height:`${radius}px`,
    lineHeight: selected ? `${radius - 1}px` : `${radius + 1}px`,
    border: selected ? '2px yellow solid' : 'none',
    background: GetAvatarColor(name || 'NA')
  }

  return (
    <div className={styles.circle} style={circleStyle}>
      {GetAvatarText(name || 'NA')}
    </div>
  )
}

export default Avatar



// WEBPACK FOOTER //
// ./src/Components/Avatar.js